import PropTypes from "prop-types";
import * as React from "react";
import { useCurrentUser } from "../../globalState";
import { Avatar, List } from "../../themeV2";

const UserDetails = React.forwardRef(function UserDetails(
  { dense = true, fullName = false, email = false, avatar = false },
  ref,
) {
  const currentUser = useCurrentUser();

  const primary =
    fullName && currentUser.fullName
      ? currentUser.fullName
      : email
      ? currentUser.email
      : null;

  const secondary =
    fullName && currentUser.fullName && email ? currentUser.email : null;

  if (!primary) return null;

  return (
    <List.Root dense={dense} ref={ref}>
      <List.Item
        leading={
          avatar ? (
            <Avatar>
              {currentUser.fullName
                ? currentUser.fullName
                    .split(" ")
                    .map((n) => n[0])
                    .join("")
                    .slice(0, 2)
                    .toUpperCase()
                : null}
            </Avatar>
          ) : undefined
        }
        secondary={secondary}
      >
        {primary}
      </List.Item>
      <List.Divider />
    </List.Root>
  );
});

UserDetails.propTypes = {
  dense: PropTypes.bool,
  fullName: PropTypes.bool,
  email: PropTypes.bool,
  avatar: PropTypes.bool,
};

export default UserDetails;
